var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col-reverse w-full overflow-hidden text-sm h-dvh print:overflow-visible md:flex-col",attrs:{"id":"app"}},[(_vm.hasLandInsightAccess)?_c('NavbarLayout',{staticClass:"z-25 print:hidden",attrs:{"activeRoute":_vm.$route.name}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }